export default __webpack_public_path__ + "static/media/checkMark.d26c056f.svg";